import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Breadcrumb,
  Input,
  Dimmer,
  Form,
  Header,
  Loader,
  Pagination,
  Segment,
  Table,
  Select,
  Button,
} from 'semantic-ui-react';
import useApiPangeo from '../../hooks/useApiPangeo';
import ImagensModal from '../../components/ImagensModal';
import ParcelasModal from './components/ParcelasModal';
import Moment from 'react-moment';
import { voltarOuDashboard } from '../../utils/navegacao';

const opcoesRegionais = [
    { key: 1, value: 1, text: 'LAPA/SP/CAIEIRAS/PERUS/FM' },
    { key: 2, value: 2, text: 'GUARULHOS/SP' },
    { key: 3, value: 3, text: 'STO ANDRE /SCS/MAUA/SP/RGS' },
    { key: 4, value: 4, text: 'DIADEMA/SP/SBC' },
    { key: 5, value: 5, text: 'SAO MIGUEL ITAQUA/ARUJA/POA/SP' },
    { key: 6, value: 6, text: 'OUTRAS' },
    { key: 7, value: 7, text: 'MOGI DAS CRUZES' },
    { key: 8, value: 8, text: 'PRAIA GRANDE' },
    { key: 9, value: 9, text: 'JACAREI' },
    { key: 10, value: 10, text: 'SEM REGIONAL' },
];

function AcordosPlrConsulta() {
  const navigate = useNavigate();
  const { data, isLoading, getAcordoPlr } = useApiPangeo();
  const [page, setPage] = useState(1);
  const anoCorrente = new Date().getFullYear();
  
  const [filtros, setFiltros] = useState({
    dataInicioVigencia: `${anoCorrente}-01-01`,
    dataFimVigencia: `${anoCorrente}-12-31`,
    dataInicioAssinatura: `${anoCorrente}-01-01`,
    dataFimAssinatura: `${anoCorrente}-12-31`,
    nomeEmpresa: '',
    regi: '',
    orderBy: 'unidade.nome_ASC',
  });

  const handleFiltroChange = (e, { name, value }) => {
    setFiltros(prevState => ({ ...prevState, [name]: value }));
    setPage(1); 
  };
  
  const limparFiltros = () => {
    setFiltros({
      dataInicioVigencia: `${anoCorrente}-01-01`,
      dataFimVigencia: `${anoCorrente}-12-31`,
      dataInicioAssinatura: `${anoCorrente}-01-01`,
      dataFimAssinatura: `${anoCorrente}-12-31`,
      nomeEmpresa: '',
      regi: '',
      orderBy: 'unidade.nome_ASC',
    });
    setPage(1);
  };

  useEffect(() => {
    const params = { ...filtros, page };

    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    });
    
    getAcordoPlr(params);
  }, [getAcordoPlr, filtros, page]);

  return (
    <div>
      <div className="clearfix">
        <Header as="h3" style={{ float: 'left' }}>
          Consulta de Acordos de PLR
        </Header>
        <div className="breadcrumb-com-voltar">
          <Button basic size="small" onClick={() => voltarOuDashboard(navigate)}>
            Voltar
          </Button>
          <Breadcrumb>
            <Breadcrumb.Section to="/" link as={Link}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section to={`/acordos-plr?ano=${anoCorrente}&tipoApuracao=vigencia`} link as={Link}>Acordos de PLR por regional</Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Consulta de Acordos</Breadcrumb.Section>
          </Breadcrumb>
        </div>
      </div>

      <Segment>
        <Form>
          <Form.Group widths='equal'>
            <Form.Input label="Vigência (De)" type="date" name="dataInicioVigencia" value={filtros.dataInicioVigencia} onChange={handleFiltroChange} />
            <Form.Input label="Vigência (Até)" type="date" name="dataFimVigencia" value={filtros.dataFimVigencia} onChange={handleFiltroChange} />
            <Form.Input label="Assinatura (De)" type="date" name="dataInicioAssinatura" value={filtros.dataInicioAssinatura} onChange={handleFiltroChange} />
            <Form.Input label="Assinatura (Até)" type="date" name="dataFimAssinatura" value={filtros.dataFimAssinatura} onChange={handleFiltroChange} />
          </Form.Group>
          <Form.Group widths='equal'>
            <Form.Input
                label="Nome da empresa"
                icon="search"
                placeholder="Buscar..."
                name="nomeEmpresa"
                value={filtros.nomeEmpresa}
                onChange={handleFiltroChange}
            />
            <Form.Field
                control={Select}
                label="Regional"
                placeholder="Todas"
                name="regi"
                options={opcoesRegionais}
                value={filtros.regi}
                onChange={handleFiltroChange}
                clearable
            />
            <Form.Field
                control={Select}
                label="Ordenar por"
                name="orderBy"
                value={filtros.orderBy}
                onChange={handleFiltroChange}
                options={[
                    { key: 'un', value: 'unidade.nome_ASC', text: 'Nome da Unidade' },
                    { key: 'da', value: 'acordoPlr.dataAssinatura_DESC', text: 'Data da Assinatura' }
                ]}
            />
          </Form.Group>
          <Button onClick={limparFiltros}>Limpar Filtros</Button>
        </Form>
      </Segment>

      <Segment>
        <Dimmer active={isLoading} inverted>
          <Loader>Aguarde ...</Loader>
        </Dimmer>
        
        <Table unstackable celled collapsing className="dnxTable">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Unidade</Table.HeaderCell>
              <Table.HeaderCell>Regional</Table.HeaderCell>
              <Table.HeaderCell>Vigência</Table.HeaderCell>
              <Table.HeaderCell>Assinatura</Table.HeaderCell>
              <Table.HeaderCell>Descrição</Table.HeaderCell>
              <Table.HeaderCell>Parcelas</Table.HeaderCell>
              <Table.HeaderCell>Documentos</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {Array.isArray(data?._embedded?.['acordo-plr']) && data?._embedded?.['acordo-plr']?.map((acordo) => (
              <Table.Row key={`${acordo?.id}`}>
                <Table.Cell data-label="Unidade">
                  <Header as="h4">
                    {acordo?._embedded?.unidade?.nome}
                    <Header.Subheader>CNPJ: {acordo?._embedded?.unidade?.cnpj}</Header.Subheader>
                  </Header>
                </Table.Cell>
                <Table.Cell data-label="Regional">
                  {acordo?._embedded?.unidade?.subregi?.descricao || '-'}
                </Table.Cell>
                <Table.Cell data-label="Vigência">
                  <Moment format="DD/MM/YYYY" date={acordo?.dataInicioVigencia?.date} />
                  {' - '}
                  <Moment format="DD/MM/YYYY" date={acordo?.dataFimVigencia?.date} />
                </Table.Cell>
                <Table.Cell data-label="Assinatura">
                  <Moment format="DD/MM/YYYY" date={acordo?.dataAssinatura?.date} />
                </Table.Cell>
                <Table.Cell data-label="Descrição">
                  {acordo?.descricao || '-'}
                  <br/>
                  <small>Trabalhadores: {new Intl.NumberFormat().format(acordo?.numeroTrabalhadores || 0)}</small>
                </Table.Cell>
                <Table.Cell>
                  <ParcelasModal parcelas={acordo?.parcelas} />
                </Table.Cell>
                <Table.Cell>
                  <ImagensModal imagens={(acordo?._embedded?.imagens ?? [])} />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="7">
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span>Total de acordos: {new Intl.NumberFormat().format(data?.total_items || 0)}</span>
                    <Pagination
                        activePage={page}
                        onPageChange={(e, { activePage }) => setPage(activePage)}
                        totalPages={data?.page_count || 0}
                    />
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Segment>
    </div>
  );
}

export default AcordosPlrConsulta;